import { loading, modal, toast, user } from "../types";
import { takeEvery, call, put } from 'redux-saga/effects';
import api from "../apis"
import { getRootDomain, guid } from "../utils/common";
import config from "../config";
import Cookies from "universal-cookie";
import microservices from "../lambdas/microservices"


export function* resetUsersStore(action) {
    yield put({ type: user.RESET_USERS_STORE_SUCCESS })
}


export function* getUserProfile() {
    try {
        const response = yield call(api.user.userprofile);
        if (response.data.code === 200) {
            yield put({ type: user.USER_PROFILE_SUCCESS, payload: response.data.data.user })
            if (response.data.data.user.wallet_applicable === 0) {
                yield put({ type: user.USER_WALLRT_APPLICABLE, payload: true })
            }
            const rootDomain = getRootDomain();
            Cookies.set(`${config.name}-isLogged`, "yes", { domain: rootDomain });
        } else {
            yield put({ type: user.USER_PROFILE_FAILURE, payload: { message: 'Oops Something went wrong' } })
        }
    } catch (error) {
        yield put({ type: user.USER_PROFILE_FAILURE, payload: error })
    }
}


export function* getCityFromPincode(action) {
    const { pincode, index } = action.payload
    try {
        const response = yield call(api.cities.getCityFromPincode, {}, {}, {}, { pincode })
        if (response.data.code === 200) {
            let data = response.data.data
            data.index = index
            yield put({ type: user.GET_CITY_FROM_PINCODE_SUCCESS, payload: data })
        } else {
            yield put({ type: user.GET_CITY_FROM_PINCODE_FAILURE, payload: { message: response.data.message, index } })
        }
    } catch (error) {
        yield put({ type: user.GET_CITY_FROM_PINCODE_FAILURE, payload: { message: error } })
    }
}


export function* getAllCities(action) {
    try {
        const response = yield call(api.cities.getAll, {})
        if (response.data.code === 200) {
            let cities = [];
            response.data.data.city_list.map(city => {
                return cities.push({
                    key: `${guid()}_${city.city_id}_${city.fk_state_id}`,
                    value: city.city_id,
                    text: `${city.city_name}, ${city.state.state_name}`
                })
            })
            yield put({ type: user.CITIES_LIST_SUCCESS, payload: cities })
        } else {
            yield put({ type: user.CITIES_LIST_FAILURE, payload: { message: 'Oops Something went wrong' } })
        }
    } catch (error) {
        yield put({ type: user.CITIES_LIST_FAILURE, payload: { message: error } })
    }
}


export function* gstValidation(action) {
    const { gst_number, customerId } = action.payload
    let data = {
        "action": "GST",
        "data": {
            "gstin_number": `${gst_number}`,
            "portal": "HORIZON",
            customerId: customerId
        }
    }
    yield put({ type: loading.MODAL_BUTTON_LOADING, payload: true })
    try {
        const response = yield call(microservices.user.gstValidation, {}, {}, {}, data);
        if (response.data.code === 200) {
            yield put({ type: loading.MODAL_BUTTON_LOADING, payload: false })
            yield put({ type: user.GST_VALIDATION_SUCCESS, payload: response.data.message_code })
            yield put({ type: toast.SEND_TOAST, payload: { status: "success", message: "GST Verification Success" } })
            yield put({ type: modal.CLOSE_MODAL, payload: {} })
        } else {
            yield put({ type: toast.SEND_TOAST, payload: { status: "success", message: "GST Verification Failed - Something went wrong" } })
            yield put({ type: user.GST_VALIDATION_FAILURE, payload: { message: 'Oops Something went wrong' } })
            yield put({ type: loading.MODAL_BUTTON_LOADING, payload: false })
        }
    } catch (error) {
        yield put({ type: user.GST_VALIDATION_FAILURE, payload: error })
        yield put({ type: loading.MODAL_BUTTON_LOADING, payload: false })
    }
    yield put({ type: loading.MODAL_BUTTON_LOADING, payload: false })

}

export default function* userSaga() {
    yield takeEvery(user.RESET_USERS_STORE_REQUEST, resetUsersStore)
    yield takeEvery(user.USER_PROFILE_REQUEST, getUserProfile)
    yield takeEvery(user.GET_CITY_FROM_PINCODE_REQUEST, getCityFromPincode)
    yield takeEvery(user.CITIES_LIST_REQUEST, getAllCities)
    yield takeEvery(user.GST_VALIDATION_REQUEST, gstValidation)
}